import { NgModule } from '@angular/core';
import { LockerTypePage } from './locker-type.page';
import { SharedModule } from 'app/shared.module';
import { OfferLockerComponent } from 'app/components/shared/offer-locker/offer-locker.component';


@NgModule({
  imports: [
    SharedModule,
    OfferLockerComponent
  ],
  declarations: [LockerTypePage]
})
export class LockerTypePageModule {}
